import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-643007b3"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "mv"
};
const _hoisted_2 = {
  class: "mvTop"
};
const _hoisted_3 = {
  class: "mvVideo"
};
const _hoisted_4 = ["src", "poster"];
const _hoisted_5 = {
  class: "mvname"
};
const _hoisted_6 = ["src"];
const _hoisted_7 = {
  class: "name"
};
const _hoisted_8 = {
  class: "nav"
};
const _hoisted_9 = {
  class: "title"
};
const _hoisted_10 = ["src"];
const _hoisted_11 = {
  class: "comment"
};
const _hoisted_12 = ["src", "onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_icon = _resolveComponent("van-icon");

  const _component_van_tab = _resolveComponent("van-tab");

  const _component_van_tabs = _resolveComponent("van-tabs");

  const _component_LikeMv = _resolveComponent("LikeMv");

  const _component_van_popup = _resolveComponent("van-popup");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_van_icon, {
    name: "arrow-left",
    size: "25",
    onClick: _cache[0] || (_cache[0] = $event => _ctx.$router.go(-1))
  })]), _createElementVNode("div", _hoisted_3, [_createElementVNode("video", {
    class: "video",
    src: $data.url,
    controls: "",
    poster: $data.cover
  }, null, 8, _hoisted_4), _createElementVNode("div", _hoisted_5, [_createElementVNode("img", {
    src: $data.arurl,
    alt: ""
  }, null, 8, _hoisted_6), _createElementVNode("span", _hoisted_7, _toDisplayString($data.name) + " -" + _toDisplayString($data.arname), 1)])]), _createElementVNode("div", _hoisted_8, [_createVNode(_component_van_tabs, {
    modelValue: $data.active,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.active = $event)
  }, {
    default: _withCtx(() => [_createVNode(_component_van_tab, {
      class: "left",
      title: "评论"
    }, {
      default: _withCtx(() => [$data.commentlist !== '' ? (_openBlock(true), _createElementBlock(_Fragment, {
        key: 0
      }, _renderList($data.commentlist, item => {
        return _openBlock(), _createElementBlock("div", {
          class: "list",
          key: item.commentId
        }, [_createElementVNode("div", _hoisted_9, [_createElementVNode("img", {
          src: item.user.avatarUrl,
          alt: ""
        }, null, 8, _hoisted_10), _createElementVNode("span", null, _toDisplayString(item.user.nickname), 1), _createElementVNode("i", null, _toDisplayString(item.timeStr), 1)]), _createElementVNode("div", _hoisted_11, [_createElementVNode("p", null, _toDisplayString(item.content), 1)])]);
      }), 128)) : _createCommentVNode("", true)]),
      _: 1
    }), _createVNode(_component_van_tab, {
      class: "right",
      title: "相关mv"
    }, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.likeMvList, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          class: "likemv",
          key: index
        }, [_createElementVNode("img", {
          src: item.cover,
          alt: "",
          onClick: $event => $options.play(index)
        }, null, 8, _hoisted_12), _createElementVNode("div", null, [_createElementVNode("h3", null, _toDisplayString(item.name), 1), _createElementVNode("span", null, _toDisplayString(item.artistName), 1), _createElementVNode("p", null, _toDisplayString(item.briefDesc), 1), _createElementVNode("span", null, _toDisplayString(item.playCount) + "次播放", 1)])]);
      }), 128))]),
      _: 1
    })]),
    _: 1
  }, 8, ["modelValue"])]), _createVNode(_component_van_popup, {
    show: $data.isPopups,
    "onUpdate:show": _cache[2] || (_cache[2] = $event => $data.isPopups = $event),
    style: {
      width: '100%'
    }
  }, {
    default: _withCtx(() => [_createVNode(_component_LikeMv, {
      mvid: $data.likeMvId,
      name: $data.name,
      arname: $data.arname
    }, null, 8, ["mvid", "name", "arname"])]),
    _: 1
  }, 8, ["show"])]);
}